import React from 'react';
import { X, Download } from 'lucide-react';

const ImagePreviewModal = ({ imageUrl, altText, onClose }) => {
  if (!imageUrl) return null;

  const handleDownload = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = altText || 'image.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // 如果下载失败，尝试在新窗口打开
      window.open(imageUrl, '_blank');
    }
  };

  return (
    <div 
      className="absolute inset-0 bg-black bg-opacity-90 z-[60] flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-center">
        <span className="text-white text-sm">{altText}</span>
        <div className="flex gap-3">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDownload();
            }}
            className="p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white transition-all"
            aria-label="下载图片"
          >
            <Download size={20} />
          </button>
          <button
            onClick={onClose}
            className="p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full text-white transition-all"
            aria-label="关闭"
          >
            <X size={20} />
          </button>
        </div>
      </div>

      {/* Image */}
      <img
        src={imageUrl}
        alt={altText}
        className="max-w-full max-h-full object-contain"
        onClick={(e) => e.stopPropagation()}
      />

      {/* Hint */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-xs opacity-70">
        点击背景关闭
      </div>
    </div>
  );
};

export default ImagePreviewModal;
